import { render, staticRenderFns } from "./return-exam-form-modal.vue?vue&type=template&id=29f87c66"
import script from "./return-exam-form-modal.vue?vue&type=script&lang=ts"
export * from "./return-exam-form-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports